import { Admin } from "./admin.model";
import { AuthType } from "../models";
import { DocumentData } from "@angular/fire/firestore";

export class AdminBuilder {
  public type: AuthType;
  public description: string;
  public venues: string[];
  public cities: string[];
  public createdBy: string;
  public editedBy: string;
  public hasFullAccess: boolean;
  constructor() {}

  edit(admin: Admin): AdminBuilder {
    this.type = admin.type;
    this.description = admin.description;
    this.venues = admin.venues;
    this.cities = admin.cities;
    this.createdBy = admin.createdBy;
    this.editedBy = admin.editedBy;
    this.hasFullAccess = admin.hasFullAccess;
    return this;
  }
  load(data: DocumentData): AdminBuilder {
    this.type = data.type;
    this.description = data.description;
    this.venues = data.venues;
    this.cities = data.cities;
    this.createdBy = data.createdBy;
    this.editedBy = data.editedBy;
    this.hasFullAccess = data.hasFullAccess;
    return this;
  }

  build(): Admin {
    return new Admin(this);
  }
}
